import React from 'react';
import PropTypes from 'prop-types';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from 'v5/design-system/DropdownMenu';
import { Trash2 } from 'lucide-react';

const CalendarDeletePopover = ({ id, trigger, handleDelete, label }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild className="">
      <div>{trigger}</div>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start">
      <DropdownMenuItem
        onClick={() => handleDelete(id)}
        className=""
        variant="destructive"
      >
        <Trash2 />
        {label}
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);

export default CalendarDeletePopover;
